
import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useOnboardingContext } from '@/context/OnboardingContext';

const SuccessStep: React.FC = () => {
  const navigate = useNavigate();
  const { loadUserData } = useOnboardingContext();
  const [isRedirecting, setIsRedirecting] = React.useState(false);
  
  useEffect(() => {
    // Safe redirection without clearing cache or forcing page reload
    const handleRedirection = async () => {
      try {
        setIsRedirecting(true);
        console.log('Starting safe redirection process...');
        
        // Ensure user data is properly loaded
        loadUserData();
        console.log('User data refreshed successfully');
        
        // Create a backup in sessionStorage as safety measure
        const userData = localStorage.getItem('userData');
        if (userData) {
          sessionStorage.setItem('userData_backup', userData);
          console.log('Created backup of user data in sessionStorage');
        }
        
        // Small delay to ensure everything is ready, then navigate safely
        setTimeout(() => {
          console.log('Navigating to home page with React Router');
          navigate('/', { replace: true });
        }, 2000);
        
      } catch (error) {
        console.error('Error during redirection process:', error);
        // Still navigate even if there's an error, but safely
        navigate('/', { replace: true });
      }
    };
    
    handleRedirection();
  }, [loadUserData, navigate]);

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-center">Vérification réussie!</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center space-y-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
          {isRedirecting ? (
            <Loader2 className="w-8 h-8 text-green-600 animate-spin" />
          ) : (
            <Check className="w-8 h-8 text-green-600" />
          )}
        </div>
        <p className="text-center text-muted-foreground">
          Votre adresse email a été vérifiée avec succès. Vous allez être redirigé vers la page d'accueil...
        </p>
      </CardContent>
    </Card>
  );
};

export default SuccessStep;
